module.exports = __webpack_public_path__ + "static/media/freedom_leadgen.297902e9.jpg";